module.exports = {"140429100":"丰州镇","140429101":"洪水镇","140429102":"蟠龙镇","140429103":"监漳镇","140429104":"故城镇","140429105":"韩北镇","140429202":"大有乡","140429203":"贾豁乡","140429205":"上司乡","140429206":"石北乡","140429207":"涌泉乡","140429208":"分水岭乡","140429400":"武乡经济技术开发区","140429401":"武乡县现代农业产业示范区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140429.json
// module id = 390
// module chunks = 0